import { CommonData } from '../common_schema'

export const brBackupData: CommonData[] = [
  {
    name: 'BR Running Status',
    mean: '[manual]',
    std: '[manual]',
    location: '[manual] Dev Tier TiDB in One Screen --> Backup/Restore Duration'
  },
  {
    name: 'BR Running Duration',
    mean: '[manual]',
    std: '[manual]',
    location: '[manual] Dev Tier TiDB in One Screen --> Backup/Restore Duration'
  },
  {
    name: 'Backup CPU Utilization(max for the duration)',
    mean: 'Backup_CPU_Util:total.values.mean',
    std: 'Backup_CPU_Util:total.values.std',
    location: 'TiKV-Details --> Backup & Import --> Backup CPU Utilization'
  },
  {
    name: 'Backup Thread Count(headroom)',
    mean: 'Backup_Thread_Count:total.values.mean',
    std: 'Backup_Thread_Count:total.values.std',
    location: 'TiKV-Details --> Backup & Import --> Backup Thread Count'
  },
  {
    name: 'KV Cursor Operations (For checksum table & index)',
    mean: 'Copr_Scan_for_checksum_index_table_OPS:total.values.mean',
    std: 'Copr_Scan_for_checksum_index_table_OPS:total.values.std',
    location:
      'TiKV-Details  --> Coprocessor Overview --> Total KV Cursor Operations'
  },
  {
    name: 'Total KV Cursor Operations',
    mean: 'Copr_Scan_for_OPS:total.values.mean',
    std: 'Copr_Scan_for_OPS:total.values.std',
    location:
      'TiKV-Details  --> Coprocessor Overview --> Total KV Cursor Operations'
  },
  {
    name: 'When is the backup moment? On business time?',
    mean: '[manual]',
    std: '[manual]',
    location:
      '[manual] TiKV-Details --> Backup & Import --> Backup CPU Utilization'
  },
  {
    name: `Impact to top level's Duration and QPS?`,
    mean: '[manual]',
    std: '[manual]',
    location: '[manual]'
  }
]
